var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.open,
            title: "Please set the recipient name first",
            width: "6.5rem",
          },
          on: {
            "update:visible": function ($event) {
              _vm.open = $event
            },
            closed: _vm.handleCancel,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "You recipient name",
                    prop: "recipientName",
                    rules: [
                      {
                        required: true,
                        message: "Please input you recipient name",
                        trigger: "blur",
                      },
                      {
                        pattern: /^[a-zA-Z0-9]{3,30}$/,
                        message:
                          "You need to fill in 3-30 characters, letters and numbers are supported.",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.recipientName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "recipientName", $$v)
                      },
                      expression: "form.recipientName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("Cancel"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: { click: _vm.handleSubmite },
                },
                [_vm._v("\n        Confirm\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }